(() => {
  const BTN_SEL =
    'button.product-add-to-cart__button.add-to-cart, .js-product-add-to-cart-button-text';
  const FORM_SEL = 'form[action="/cart/add"], form[action^="/cart/add"]';

  console.log('[DA DIR] da-directional.js loaded');

  function findFormFromTarget(el) {
    return el?.closest?.(FORM_SEL) || el?.closest?.('form');
  }

  function findDirectionalBoxNear(form) {
    if (!form) return null;
    return (
      form.querySelector('.da-directional-box[data-directional]') ||
      (form.closest('[id^="shopify-section"], .shopify-section, [data-section-id]') || document)
        .querySelector('.da-directional-box[data-directional]') ||
      document.querySelector('.da-directional-box[data-directional]')
    );
  }

  function getPurchaseType(box) {
    const sel = box.querySelector('.da-directional-box__select');
    return sel ? String(sel.value || '').trim() : 'replacement';
  }

  function getPairVariantId(box) {
    const input = box.querySelector('input[id^="DirectionalPairVariantId-"]');
    const v = (input?.value || '').trim();
    return v ? parseInt(v, 10) : null;
  }

  function getDirectionalSide(box) {
    const raw =
      (box.getAttribute('data-directional-side') || '').trim() ||
      (box.querySelector('input[id^="DirectionalSide-"]')?.value || '').trim();
    if (!raw) return 'Selected';
    return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
  }

  function getOppositeSide(side) {
    if (side.toLowerCase() === 'right') return 'Left';
    if (side.toLowerCase() === 'left') return 'Right';
    return 'Selected';
  }

  function getCurrentVariantId(form) {
    const fromForm =
      (form?.querySelector?.('[name="id"]')?.value || '').trim() ||
      (form?.querySelector?.('input[name="id"]')?.value || '').trim();
    if (fromForm) return parseInt(fromForm, 10);
    const metaId = window.ShopifyAnalytics?.meta?.selectedVariantId;
    if (metaId) return parseInt(metaId, 10);
    const prod = window.meta?.product;
    const v2 = prod?.selected_or_first_available_variant?.id;
    if (v2) return parseInt(v2, 10);
    return null;
  }

  function buildItems(purchaseType, currentVariantId, pairVariantId) {
    switch (purchaseType) {
      case 'pair_same_current': return [{ id: currentVariantId, quantity: 2 }];
      case 'pair_same_other':   return [{ id: pairVariantId, quantity: 2 }];
      case 'pair_mixed':        return [{ id: currentVariantId, quantity: 1 }, { id: pairVariantId, quantity: 1 }];
      case 'full_set':          return [{ id: currentVariantId, quantity: 2 }, { id: pairVariantId, quantity: 2 }];
      default:                  return null;
    }
  }

  async function clearVariantsFromCart(variantIds) {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return;
      const cart = await res.json();
      const updates = {};
      for (const item of cart.items) {
        if (variantIds.includes(item.variant_id)) updates[item.key] = 0;
      }
      if (Object.keys(updates).length === 0) return;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
    } catch (err) {
      console.error('[DA DIR] clearVariantsFromCart error:', err);
    }
  }

  // Test a single variant by trying to add qty 2
  // Reads the raw response text to determine status regardless of HTTP code
  // Returns 'ok', 'low_inventory', or 'out_of_stock'
  async function testVariant(variantId, variantIds) {
    try {
      await clearVariantsFromCart(variantIds);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 2 }] })
      });

      const text = await res.text();
      await clearVariantsFromCart(variantIds);

      const msg = text.toUpperCase();

      // Low inventory — Shopify added 1 but couldn't add 2
      if (msg.includes('ONLY 1 ITEM WAS ADDED') || msg.includes('DUE TO AVAILABILITY')) {
        return 'low_inventory';
      }

      // Out of stock — hard rejection
      if (msg.includes('SOLD OUT') || msg.includes('OUT OF STOCK') || msg.includes('ALREADY SOLD OUT')) {
        return 'out_of_stock';
      }

      // HTTP ok and no issues = good
      if (res.ok) return 'ok';

      // Any other error = treat as out of stock
      return 'out_of_stock';

    } catch (err) {
      await clearVariantsFromCart(variantIds);
      return 'out_of_stock';
    }
  }

  function buildIssueMessage(issues) {
    const lines = issues.map(issue => {
      if (issue.type === 'out_of_stock') {
        return `The ${issue.side.toLowerCase()} wheel is out of stock.`;
      } else {
        return `Only 1 ${issue.side.toLowerCase()} wheel is in stock but you need 2.`;
      }
    });
    return lines.join('\n');
  }

  function buildReducedItems(items, issues) {
    return items.map(item => {
      const issue = issues.find(i => i.variantId === item.id);
      if (!issue) return item;
      if (issue.type === 'out_of_stock') return null;
      if (issue.type === 'low_inventory') return { ...item, quantity: 1 };
      return item;
    }).filter(Boolean);
  }

  function showInventoryPopup(message, onConfirm, confirmLabel) {
    const existing = document.querySelector('.wheel-restriction-popup');
    if (existing) existing.remove();

    // Remember what was focused before opening, so we can restore it on close
    const previouslyFocused = document.activeElement;

    const wrapper = document.createElement('div');
    wrapper.className = 'wheel-restriction-popup';

    const overlay = document.createElement('div');
    overlay.className = 'wheel-restriction-overlay';

    const modal = document.createElement('div');
    modal.className = 'wheel-restriction-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'wheel-restriction-title');
    modal.setAttribute('tabindex', '-1');

    // Hidden title for screen readers
    const srTitle = document.createElement('h2');
    srTitle.id = 'wheel-restriction-title';
    srTitle.textContent = 'Attention';
    srTitle.style.cssText = 'position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden;';
    modal.appendChild(srTitle);

    const content = document.createElement('div');
    content.className = 'wheel-restriction-content';
    content.style.cssText = 'text-align:center;';

    const lines = message.split('\n');
    lines.forEach((line, i) => {
      const p = document.createElement('p');
      p.style.cssText = i < lines.length - 1 ? 'margin:0 0 8px 0;' : 'margin:0 0 16px 0;';
      p.textContent = line;
      content.appendChild(p);
    });

    if (onConfirm) {
      const yesBtn = document.createElement('button');
      yesBtn.type = 'button';
      yesBtn.className = 'wheel-restriction-notify-btn';
      yesBtn.style.cssText = 'color:#b1081c; font-weight:600; text-decoration:underline; background:none; border:none; cursor:pointer; padding:0; margin-bottom:12px; font-size:inherit; display:block; text-align:center; width:100%;';
      yesBtn.textContent = confirmLabel || "Yes, Add What's Available to Cart";
      yesBtn.addEventListener('click', () => { cleanup(); onConfirm(); });
      content.appendChild(yesBtn);
    }

    const notifyBtn = document.createElement('button');
    notifyBtn.type = 'button';
    notifyBtn.className = 'wheel-restriction-notify-btn';
    notifyBtn.style.cssText = 'color:#b1081c; font-weight:600; text-decoration:underline; background:none; border:none; cursor:pointer; padding:0; margin-bottom:20px; font-size:inherit; display:block; text-align:center; width:100%;';
    notifyBtn.textContent = 'Notify Me When More Are Available';
    notifyBtn.addEventListener('click', () => {
      cleanup();
      const existingNotifyBtn = document.querySelector('.js-notify-me-button');
      if (existingNotifyBtn) existingNotifyBtn.click();
    });
    content.appendChild(notifyBtn);

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'wheel-restriction-close';
    closeBtn.style.cssText = 'margin-top:8px;';
    closeBtn.textContent = 'No, Take Me Back';
    closeBtn.setAttribute('aria-label', 'Close dialog and return to product page');
    closeBtn.addEventListener('click', cleanup);

    overlay.addEventListener('click', cleanup);

    modal.appendChild(content);
    modal.appendChild(closeBtn);
    wrapper.appendChild(overlay);
    wrapper.appendChild(modal);
    document.body.appendChild(wrapper);

    // Build list of focusable elements inside the modal
    const focusableElements = modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    // Auto-focus the first interactive element so screen readers announce the dialog
    if (firstFocusable) firstFocusable.focus();

    // Focus trap + ESC key handler
    function handleKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        cleanup();
        return;
      }

      if (e.key === 'Tab') {
        if (focusableElements.length === 0) {
          e.preventDefault();
          return;
        }
        if (e.shiftKey && document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
        else if (!e.shiftKey && document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }

    document.addEventListener('keydown', handleKeydown);

    // Cleanup function — removes modal and event listeners, restores focus
    function cleanup() {
      document.removeEventListener('keydown', handleKeydown);
      wrapper.remove();
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus();
      }
    }
  }

  async function addItems(items, properties) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items.map(i => ({ ...i, properties })) })
    });
    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(errorText);
    }
    return res.json();
  }

  function stopEvent(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  function setBtnLoading(btn, on) {
    if (!btn) return;
    btn.disabled = on;
    btn.classList.toggle('is-loading', on);
  }

  async function handle(e) {
    const hit = e.target?.closest?.(BTN_SEL);
    if (!hit) return;

    const btn = hit.closest('button');
    if (!btn) return;

    const form = findFormFromTarget(btn);
    if (!form) return;

    const box = findDirectionalBoxNear(form);
    if (!box) return;

    const purchaseType = getPurchaseType(box);
    if (purchaseType === 'replacement') return;

    const currentVariantId = getCurrentVariantId(form);
    const pairVariantId = getPairVariantId(box);

    const items = buildItems(purchaseType, currentVariantId, pairVariantId);
    if (!items) return;

    stopEvent(e);
    setBtnLoading(btn, true);

    const currentSide = getDirectionalSide(box);
    const pairSide = getOppositeSide(currentSide);

    const props = {
      _purchase_type: purchaseType,
      _directional_side: currentSide,
      _directional_pair_variant_id: String(pairVariantId)
    };

    const variantIds = [currentVariantId, pairVariantId].filter(Boolean);

    try {
      await clearVariantsFromCart(variantIds);
      await addItems(items, props);
      window.location.href = '/cart';

    } catch (err) {
      console.error('[DA DIR] addItems failed:', err);

      // Clear anything Shopify may have added
      await clearVariantsFromCart(variantIds);

      if (purchaseType === 'full_set') {
        // Always diagnose each side individually for full_set
        // testVariant reads raw response text so both 'low_inventory' and 'out_of_stock' 
        // are correctly identified regardless of HTTP status code
        const currentStatus = await testVariant(currentVariantId, variantIds);
        const pairStatus = await testVariant(pairVariantId, variantIds);

        // Final clear before showing popup
        await clearVariantsFromCart(variantIds);

        const issues = [];
        if (currentStatus !== 'ok') issues.push({ side: currentSide, type: currentStatus, variantId: currentVariantId });
        if (pairStatus !== 'ok') issues.push({ side: pairSide, type: pairStatus, variantId: pairVariantId });

        if (issues.length === 0) {
          await addItems(items, props);
          window.location.href = '/cart';
          return;
        }

        const reducedItems = buildReducedItems(items, issues);
        const canAdd = reducedItems.length > 0;

        // Pick confirm label based on what's available
        let confirmLabel = null;
        if (canAdd) {
          const allLow = issues.every(i => i.type === 'low_inventory');
          confirmLabel = allLow ? 'Yes, Add 1 of Each to Cart' : "Yes, Add What's Available to Cart";
        }

        showInventoryPopup(
          buildIssueMessage(issues),
          canAdd ? async () => {
            try {
              await clearVariantsFromCart(variantIds);
              await addItems(reducedItems, props);
              window.location.href = '/cart';
            } catch (retryErr) {
              console.error('[DA DIR] addItems (reduced full_set) failed:', retryErr);
            }
          } : null,
          confirmLabel
        );

      } else {
        // Non full_set — single side issue
        let errorData = {};
        try { errorData = JSON.parse(err.message); } catch (_) {}
        const rawMessage = errorData?.description || errorData?.message || err.message || '';
        const msg = rawMessage.toUpperCase();

        if (msg.includes('ONLY 1 ITEM WAS ADDED') || msg.includes('DUE TO AVAILABILITY')) {
          // Low inventory
          const lowStockItem = items.find(i => i.quantity === 2);
          const lowStockVariantId = lowStockItem?.id;
          const side = lowStockVariantId === currentVariantId ? currentSide : pairSide;

          showInventoryPopup(
            `Only 1 ${side.toLowerCase()} wheel is in stock but you need 2. Would you like to add 1 to your cart anyway?`,
            async () => {
              try {
                await clearVariantsFromCart(variantIds);
                const reducedItems = items.map(i =>
                  i.id === lowStockVariantId ? { ...i, quantity: 1 } : i
                );
                await addItems(reducedItems, props);
                window.location.href = '/cart';
              } catch (retryErr) {
                console.error('[DA DIR] addItems (reduced) failed:', retryErr);
              }
            },
            'Yes, Add 1 to Cart'
          );

        } else {
          // Out of stock
          const t = rawMessage.toUpperCase();
          let side = 'Selected';
          if (t.includes('-LEFT') || t.includes('LEFT WHEEL') || t.includes('LEFT-')) side = 'Left';
          else if (t.includes('-RIGHT') || t.includes('RIGHT WHEEL') || t.includes('RIGHT-')) side = 'Right';

          showInventoryPopup(
            `Unfortunately the ${side.toLowerCase()} wheel is out of stock.`,
            null,
            null
          );
        }
      }

    } finally {
      setBtnLoading(btn, false);
    }
  }

  document.addEventListener('pointerdown', handle, true);
  document.addEventListener('click', handle, true);
})();